module.exports = __webpack_public_path__ + "static/media/bolt.6f1ab4b1.png";